import { DEFAULT_MENU_CATALOG_OWNER, Store } from '../models/Store';

export const MENU_CATALOG_POSCAISSE_MESSAGE =
  'Ce catalogue est géré par POSCaisse/BackOffice. Modifiez le menu dans BO/POSCaisse puis publiez online.';

export const isMenuCatalogManagedByPosCaisse = (
  store?: Pick<Store, 'menuCatalogOwner'> | null
): boolean => (store?.menuCatalogOwner || DEFAULT_MENU_CATALOG_OWNER) === 'POSCAISSE';
